import axios from 'axios'
import router from '@/router/index'
import store from '@/store/index'
import { ElMessage } from 'element-plus'

const toLogin = () => {
    router.push({
        name: 'login',
        query: {
            redirect: router.currentRoute.value.path !== '/login' ? router.currentRoute.value.fullPath : undefined
        }
    })
}
let loginLoading = false
const setLoginLoading = (timer = 1000) => {
    loginLoading = true
    setTimeout(() => {
        loginLoading = false
    }, timer)
}
const api = axios.create({
    baseURL: import.meta.env.DEV && import.meta.env.VITE_OPEN_PROXY === 'true' ? '/proxy/' : import.meta.env.VITE_APP_API_BASEURL,
    // baseURL: import.meta.env.VITE_APP_API_BASEURL,
    timeout: 10000,
    responseType: 'json'
})
// 处理get中时间筛选 需要传递encodeURI('params[beginTime]')这样的参数
// api.defaults.paramsSerializer = params => {
//     return Object.keys(params).filter(it => {
//         return params.hasOwnProperty(it)
//     }).reduce((pre, curr) => {
//         return params[curr] ? (pre ? pre + '&' : '') + curr + '=' + encodeURIComponent(params[curr]) : pre
//     }, '')
// }
api.interceptors.request.use(
    request => {
        /**
         * 全局拦截请求发送前提交的参数
         * 以下代码为示例，在请求头里带上 token 信息
         */
        if (store.getters['user/isLogin']) {
            request.headers['Authorization'] = store.state.user.token

        }
        request.headers['from_site'] = store.state.settings.fromSite
        return request
    }
)

api.interceptors.response.use(
    response => {
        /**
         * 全局拦截请求发送后返回的数据，如果数据有报错则在这做全局的错误提示
         * 假设返回数据格式为：{ code: 1, error: '', data: '' }
         * 规则是当 code 为 1 时表示请求成功，为 0 时表示接口需要登录或者登录状态失效，需要重新登录
         * 请求出错时 error 会返回错误信息
         */
        if (response.data.code !== 1) {
            if (response.data.code === -1) {
                store.dispatch('user/logout').then(() => {
                    if (!loginLoading) {
                        setLoginLoading()
                        toLogin()
                    }

                })
            } else {
                ElMessage.error(`${response.data.msg}`)
                return Promise.reject(response.data)

            }
        } else {
            console.log('')
            return Promise.resolve(response.data)
        }

    },
    error => {
        let message = error.message
        if (message == 'Network Error') {
            message = '后端网络故障'
        } else if (message.includes('timeout')) {
            message = '接口请求超时'
        } else if (message.includes('Request failed with status code')) {
            message = '接口' + message.substr(message.length - 3) + '异常'
        }
        ElMessage({
            message,
            type: 'error'
        })
        return Promise.reject(error)
    }
)

export default api
